import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';
import { defineMessages, useIntl } from '@atlas/text';

export const messages = defineMessages({
    image: { id: 'lblIconImage', defaultMessage: 'Image' },
});

const ImageIcon = React.memo(function ImageIcon(props: TImageIconProps): React.ReactElement {
    const intl = useIntl();

    return (
        <IconBase aria-label={intl.formatMessage(messages.image)} {...props}>
            <path
                clipRule="evenodd"
                fillRule="evenodd"
                d="M4.5 15.059V16.5h14v-3.94a.752.752 0 0 1-.052-.053l-1.72-1.873a1.25 1.25 0 0 0-1.854.013l-2.524 2.827a2.75 2.75 0 0 1-3.928.18l-.355-.332a1.25 1.25 0 0 0-1.706 0l-1.85 1.726a.736.736 0 0 1-.011.011Zm0-2.052.838-.782a2.75 2.75 0 0 1 3.753 0l.355.332a1.25 1.25 0 0 0 1.785-.082l2.524-2.827a2.75 2.75 0 0 1 4.077-.029l.668.728V5.5h-14v7.507ZM4 4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H4Zm7.75 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
            />
        </IconBase>
    );
});

export default ImageIcon;

// #region Types

export type TImageIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <ImageIcon /> : { ...IconBaseExample, render: ImageIcon };

// #endregion
